var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgElevator = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 2H11V21.3178V22H9H2H0V20V2V0H2H9H11H18H20V2V22H11V20H18V2ZM2 2H9V20H2V2ZM5.5 9.5L8 12.5H3L5.5 9.5ZM17 9.5L14.5 12.5L12 9.5H17Z",
    fill: "#131313"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgElevator, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/elevator.6ee4a451.svg";
export { ForwardRef as ReactComponent };